import { Empty } from "antd";
import type { ReactNode } from "react";

interface EmptyStateProps {
	/** Description text explaining why it's empty / what to do. */
	description?: ReactNode;
	/** Optional action (e.g. a "Qo'shish" button). */
	action?: ReactNode;
	/** Use the larger default illustration instead of the simple one. */
	large?: boolean;
	className?: string;
}

/**
 * Standard empty state. Wraps AntD `Empty` with a consistent illustration and spacing
 * so modules stop mixing `Empty.PRESENTED_IMAGE_SIMPLE`, the default image, and ad-hoc text.
 */
export function EmptyState({ description, action, large, className }: EmptyStateProps) {
	return (
		<div className={`py-8 ${className ?? ""}`}>
			<Empty
				image={large ? Empty.PRESENTED_IMAGE_DEFAULT : Empty.PRESENTED_IMAGE_SIMPLE}
				description={description ?? "Ma'lumot topilmadi"}
			>
				{action}
			</Empty>
		</div>
	);
}
